import * as React from 'react';

import {TextField} from '@mui/material';
import { Typography } from '@mui/material/';
import {useFormContext} from 'react-hook-form';
import { Controller } from "react-hook-form"

const FormTextField = ({name, label, required, rules = {}, shrinkLabel=undefined,expand = false,...props}) => {

  const {control, formState } = useFormContext();

  const errors = formState.errors

  const requiredDefaultRule = required ? { required: { value: true, message: "This field is required" } } : {};
  rules = { ...requiredDefaultRule, ...rules };


  const expandProps = {}
  if (expand) {
    expandProps['minRows'] = 1;
    expandProps['maxRows'] = 10;
    expandProps['multiline'] = true;
  }


  return (
    <Controller
        render={({field: {onChange, value, onBlur}}) =>(
          <TextField
            label={label}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            variant="outlined"
            fullWidth
            required={required}
            error={!!errors[name]}
            helperText={errors[name] ? <Typography component="span">{errors[name]?.message?.toString()}</Typography> : null}
            InputLabelProps={{ shrink: shrinkLabel }}
            {...expandProps}
            {...props}
          />
        )}
        name={name}
        control={control}
        rules={rules}
    />
  );
};
export default FormTextField;